import { Page } from "react-pdf";
import { Rnd } from "react-rnd";
import { useSignature, FIELD_TYPES, fieldConfig } from "./SignatureContext";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function PdfWrite({ pageNumber, onOpenModal }) {
  const { blocks, signatures, setSignatures } = useSignature();

  const pageBlocks = blocks.filter((b) => b.pageNumber === pageNumber);

  const handleBlockClick = (block) => {
    if (signatures[block.id]) return;

    if (block.fieldType === FIELD_TYPES.DATE) {
      const today = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      setSignatures((prev) => ({
        ...prev,
        [block.id]: today,
      }));
    } else {
      onOpenModal(block.id);
    }
  };

  return (
    <div className="relative">
      <Page
        pageNumber={pageNumber}
        renderAnnotationLayer={false}
        renderTextLayer={false}
      />

      {pageBlocks.map((block) => {
        const config =
          fieldConfig[block.fieldType] || fieldConfig[FIELD_TYPES.SIGNATURE];
        const Icon = config.icon;
        const isSigned = !!signatures[block.id];

        return (
          <Rnd
            key={block.id}
            bounds="parent"
            disableDragging
            enableResizing={false}
            size={{ width: block.width, height: block.height }}
            position={{ x: block.x, y: block.y }}
            onClick={() => handleBlockClick(block)}
            className={cn(
              "group relative z-20 rounded-lg transition-all cursor-pointer",
              isSigned
                ? ""
                : `border-2 border-dashed ${config.borderColor} ${config.dashedBg}`,
            )}
          >
            {isSigned ? (
              block.fieldType === FIELD_TYPES.DATE ? (
                <div className="flex h-full w-full items-center justify-center px-2">
                  <span className={cn("text-sm font-semibold", "text-black")}>
                    {signatures[block.id]}
                  </span>
                </div>
              ) : (
                <img
                  src={signatures[block.id]}
                  alt={
                    block.fieldType === FIELD_TYPES.INITIAL
                      ? "Initials"
                      : "Signature"
                  }
                  className="h-full w-full object-contain"
                />
              )
            ) : (
              <div className="absolute inset-0 flex items-center justify-center gap-1">
                <Icon size={14} className={config.textColor} />
                <span
                  className={cn(
                    "pointer-events-none select-none text-xs font-semibold",
                    "text-red-600",
                  )}
                >
                  {`${config.label.toLowerCase()}`}
                </span>
              </div>
            )}
          </Rnd>
        );
      })}
    </div>
  );
}
